import {
    Box,
    Heading,
    Stack,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import Price from "components/price";
import { useSelectedRule } from "hooks/use-selected-rule";
import { useTranslation } from "react-i18next";
import { ChargeStatus } from "types/payment";
import { isWaitList } from "utils/booking";
import { getPaymentCalculationTotal, getPaymentUnitTranslation } from "utils/payment-utils";
import { BookingSummaryItem } from "./booking-summary-list-item";

const CardRegistrationInformation = () => {
    const { t } = useTranslation();
    const { data: webBooking } = useWebBooking();
    const selectedRule = useSelectedRule();

    if (!webBooking) {
        return null;
    }

    if (!selectedRule) {
        return null;
    }

    const isWaitListBooking = isWaitList(webBooking);

    let totalValue = getPaymentCalculationTotal(
        selectedRule,
        webBooking.guests,
        webBooking.articles?.filter((x) => x.isTable)
    );

    const paymentType = webBooking.webBookingRules?.at(0)?.paymentRule;
    if (!paymentType) totalValue = webBooking.chargeShouldPayAmount;

    return (
        <Box>
            <Heading
                as="h4"
                fontWeight="500"
                fontSize={ThemeFontSizeVariable.Large}
                pb={ThemeSpaceVariable.Small}
            >
                {t("payment.paymentCardRegistration")}
            </Heading>
            <Stack spacing={ThemeSpaceVariable.XSmall} mt={ThemeSpaceVariable.Small}>
                <BookingSummaryItem
                    label={t("payment.paymentCardRegistered")}
                    value={
                        webBooking.chargeStatus === ChargeStatus.CardRegistered ? t("yes") : t("no")
                    }
                />
                {!isWaitListBooking && (
                    <BookingSummaryItem label={t("payment.noShowFee")}>
                        <Price
                            amount={totalValue}
                            display="symbol"
                            color={ThemeColorVariable.OnSurfaceSubdued}
                        />
                    </BookingSummaryItem>
                )}
                {!isWaitListBooking && paymentType && (
                    <BookingSummaryItem
                        label=""
                        value={
                            <Text color={ThemeColorVariable.OnSurfaceSubdued}>
                                (
                                <Price
                                    amount={selectedRule.paymentAmount}
                                    display="symbol"
                                    color={ThemeColorVariable.OnSurfaceSubdued}
                                />{" "}
                                / {getPaymentUnitTranslation(selectedRule)})
                            </Text>
                        }
                    />
                )}
            </Stack>
        </Box>
    );
};

export default CardRegistrationInformation;
